<template>
<!-- Container para toda la página: ******************************************************* -->
    <v-container fill-height fluid class="sign-in">
        <!-- Layout para toda la página: *********************************************************** -->
        <v-layout align-center justify-center>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 sm8 md6 lg5 elevation-6>
                <v-card class="elevation-12 pa-4" color="grey lighten-5">
                    <v-card-text>
                        <v-container grid-list-sm>
                            <v-layout row justify-space-between>
                                <v-flex shrink>
                                    <img height="120" :src="logo1" />
                                </v-flex>
                            </v-layout>
                            <v-divider class="light-blue darken-3"></v-divider>
                            <v-layout row>
                                <v-flex xs12>
                                    <div class="light-blue--text text--darken-3 headline font-weight-medium">
                                        <p></p>Inicio de Sesión
                                    </div>
                                </v-flex>
                            </v-layout>

                            <v-layout row justify-space-around>
                                <v-flex xs12>
                                    <v-form ref="form" v-model="valid" @submit.prevent>
                                        <v-container>
                                            <v-layout row justify-space-around>
                                                <v-flex xs11 sm10 md9>
                                                    <v-text-field
                                                        color="light-blue darken-3"
                                                        prepend-icon="mdi-account"
                                                        name="email"
                                                        label="Correo Electrónico"
                                                        type="email"
                                                        v-model="email"
                                                        :rules="emailRules"
                                                        required
                                                        align-self-center
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row justify-space-around>
                                                <v-flex xs11 sm10 md9>
                                                    <v-text-field
                                                        color="light-blue darken-3"
                                                        prepend-icon="mdi-lock"
                                                        name="password"
                                                        label="Contraseña"
                                                        id="password"
                                                        type="password"
                                                        required
                                                        v-model="password"
                                                        :append-icon="e1 ? 'mdi-eye-off' : 'mdi-eye'"
                                                        @click:append="() => (e1 = !e1)"
                                                        :type="e1 ? 'password' : 'text'"
                                                        :rules="passwordRules"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row>
                                                <v-spacer></v-spacer>
                                                <v-spacer></v-spacer>

                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    type="submit"
                                                    @submit.prevent="checkLogin"
                                                    @click="onSubmit"
                                                    :class="{
                                                                'light-blue darken-3 white--text': valid,
                                                                disabled: !valid
                                                            }"
                                                >OK</v-btn>
                                            </v-layout>
                                        </v-container>
                                    </v-form>
                                </v-flex>
                            </v-layout>

                            <!-- Modal para informar que el usuario o el password son incorrectos: *********************************** -->
                            <v-layout row justify-center>
                                <v-dialog v-model="failedLogin" persistent :width="errorModalWidth">
                                    <v-card class="grey lighten-4">
                                        <v-toolbar dense color="light-blue darken-4" dark flat>
                                            <v-toolbar-title
                                                class="my-list-title"
                                            >Información no válida</v-toolbar-title>
                                            <v-spacer></v-spacer>
                                            <v-icon>mdi-alert-circle</v-icon>
                                        </v-toolbar>
                                        <v-card-title>
                                            <v-container>
                                                <v-layout row>
                                                    <v-flex xs12 class="d-flex justify-center">
                                                        <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row>
                                                    <v-flex
                                                        xs12
                                                        class="d-flex justify-center text-center"
                                                    >Usuario o contraseña no válidos.</v-flex>
                                                </v-layout>
                                            </v-container>
                                        </v-card-title>

                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                color="green darken-4"
                                                class="text-none"
                                                text
                                                @click="failedLogin = false"
                                            >OK</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-layout>
                            <!-- Termina modal para informar que el usuario o el password son incorrectos *********************************** -->

                            <!-- Modal para informar que el usuario no está activo: *********************************** -->
                            <v-layout row justify-center>
                                <v-dialog
                                    v-model="inactiveUser"
                                    persistent
                                    :width="errorModalWidth"
                                >
                                    <v-card class="grey lighten-4">
                                        <v-toolbar dense color="teal" dark flat>
                                            <v-toolbar-title class="my-list-title">Usuario inactivo</v-toolbar-title>
                                            <v-spacer></v-spacer>
                                            <v-icon>error_outline</v-icon>
                                        </v-toolbar>
                                        <v-card-title>
                                            <v-container>
                                                <v-layout row>
                                                    <v-flex xs12 class="d-flex justify-center">
                                                        <v-icon
                                                            large
                                                            color="orange darken-2"
                                                        >mdi-alert</v-icon>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row>
                                                    <v-flex
                                                        xs12
                                                        class="d-flex justify-center text-center"
                                                    >El usuario no está activo en el sistema.</v-flex>
                                                </v-layout>
                                            </v-container>
                                        </v-card-title>

                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                color="teal darken-3"
                                                class="text-none"
                                                text
                                                @click="inactiveUser = false"
                                            >OK</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-layout>

                            <!-- Termina modal para informar que el usuario no está activo *********************************** -->
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-footer absolute color="black" dark>
            <v-spacer></v-spacer>
            <div>&copy; Grupo Tecnológico Santa Fe, S.A. de C.V. {{ new Date().getFullYear() }} &nbsp; v. {{ version }}</div>
        </v-footer>
    </v-container>
</template>


<script>
import { mapGetters } from 'vuex';
export default {
    data() {
        return {
            valid: false,
            e1: true,
            password: '',
            passwordRules: [v => !!v || 'Introduzca la contraseña'],
            email: '',
            emailRules: [
                v => !!v || 'Introduzca su correo electrónico',
                v =>
                    /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                    'Introduzca un correo válido'
            ]
        };
    },
    methods: {
        onSubmit() {
            if (this.$refs.form.validate()) {
                this.$store.dispatch('login', {
                    email: this.email,
                    password: this.password
                });
            }
        },
        clear() {
            this.$refs.form.reset();
        }
    },
    computed: {
        ...mapGetters(['version', 'logo1']),
        failedLogin: {
            get() {
                    return this.$store.getters.failedLogin;
            },
            set(failedLogin) {
                this.$store.dispatch('updateFailedLogin', failedLogin);
            },
        },
        inactiveUser: {
            get() {
                return this.$store.getters.inactiveUser;
            },
            set(inactiveUser) {
                this.$store.dispatch('updateInactiveUser', inactiveUser);
            }
        },
        waitCursor() {
            return this.$store.getters.waitCursor;
        },
         errorModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '70%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '50%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '30%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '20%';
            }
            return width;
        }
    },
    created() {
        //this.$store.dispatch('tryAutoLogin');
    }
};
</script>

<style scoped>
.sign-in {
    background: url('../assets/fondo1.jpg');
    background-size: cover;
    width: 100%;
    height: 100%;
}


/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>
